import { RANK_SVGS } from './rankSvgs';

export function RankNumber({ rank, className }: { rank: number; className?: string }) {
  const src = RANK_SVGS[rank];
  if (!src) {
    return null;
  }
  return <img alt="" className={className} src={src} />;
}
